import React, { useState } from "react";

// @mui/material components

import CircularProgress from '@mui/material/CircularProgress';

// @mui/icons-material
import LocalGroceryStore from "@mui/icons-material/LocalGroceryStore";
import Info from "@mui/icons-material/Info";
import Toc from "@mui/icons-material/Toc";
import Collections from "@mui/icons-material/Collections"; 

// core components
import OthelloBotonera from '../../componentsothello/OthelloBotonera.jsx';
import { DataStatePage, OpcionSiNo, TipoOthelloFieldGrid, Roles, PopUpResult, OpcionVisibilidad, Visibilidad, EstadosArticulo } from "../../othelloConstantes.jsx";
import OthelloGrid from '../../componentsothello/OthelloGrid.jsx';
import OthelloEdit from '../../componentsothello/OthelloEdit.jsx';
import NavPills from "../../components/NavPills.jsx";
import OthelloComboBox from '../../componentsothello/OthelloComboBox.jsx';
import ImageUpload from "../../components/ImageUpload.jsx";

import OthelloPopUpResult from "../../componentsothello/OthelloPopUpResult.jsx";
import OthelloTitulo from "../../componentsothello/OthelloTitulo.jsx";
import OthelloTituloPanelData from "../../componentsothello/OthelloTituloPanelData.jsx";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";



export default function Articulos({ ...props }) {
    const { literal, idRol } = props;

    const [loading, setLoading] = React.useState(true);
    const [loadingediting, setloadingediting] = React.useState(true);

    const [statePage, setstatePage] = React.useState(DataStatePage.dsSearch);
    const [statePageDefinicion, setstatePageDefinicion] = React.useState(DataStatePage.dsSearch);
    const [statePageImagenExtra, setstatePageImagenExtra] = React.useState(DataStatePage.dsSearch);

    const [datarticulos, setdatarticulos] = React.useState(null);
    const [nombretienda, setnombretienda] = React.useState("");

    const [categorias, setcategorias] = React.useState([]);
    const [marcas, setmarcas] = React.useState([]);

    const [alert, setalert] = React.useState(null);

    const [dataeditando, setdataeditando] = useState(null);
    const [indexeditando, setindexeditando] = useState(null);

    const [dataeditandoDefinicion, setdataeditandoDefinicion] = useState(null);
    const [indexeditandoDefinicion, setindexeditandoDefinicion] = useState(null);

    const [dataeditandoImagenExtra, setdataeditandoImagenExtra] = useState(null);
    const [indexeditandoImagenExtra, setindexeditandoImagenExtra] = useState(null);

    React.useEffect(() => {

        getDataNombreTienda();
        getDataPage();
        setLoading(false);
    }, [loading]);

    //METODOS GLOBALES DE LA PAGINA

    //Metodos Sobre Articulos

    const getDataNombreTienda = () => {
        fetch('api/Data/GetNombreTiendaSelected')
            .then(response => response.json())
            .then(data => {
                setnombretienda(data.nombre);
            });
    }

    const getDataPage = () =>
    {
        fetch('api/Data/GetCategorias')
            .then(response => response.json())
            .then(data => {

                let rescategorias = data.map(x => {
                    let val =
                    {
                        ...x,
                        valor: x.id_Categoria,
                        name: x.codigo
                    };

                    return val;

                })

                setcategorias(rescategorias);
            });

        fetch('api/Data/GetMarcas')
            .then(response => response.json())
            .then(data => {

                let resmarcas = data.map(x => {
                    let val =
                    {
                        ...x,
                        valor: x.id_Marca,
                        name: x.nombre
                    };

                    return val;

                })

                setmarcas(resmarcas);
            });

        fetch('api/Data/BuscarArticulosResumido')
            .then(response => response.json())
            .then(data => {
                setdatarticulos(data);
            });
    }

    const getDataVacia = () => {

        fetch('api/Data/GetArticuloVacio')
            .then(response => response.json())
            .then(data =>
            {
                setindexeditando(-1);

                setdataeditando(data);
                setstatePage(DataStatePage.dsInsert);
                setloadingediting(false);

            }).catch(error =>
            {
                setindexeditando(null);

                setdataeditando(null);
                setstatePage(DataStatePage.dsSearch);
                setloadingediting(true);              
            });
    }

    const grabarDataPage = (event) => {

        //Altero el valor que tiene el input de dias visualizando
        //try {
        //    this.refs.form[2].value = this.diasVisualizando;
        //}
        //catch { }

        //Obtengo los datos
        //const data = new FormData(this.refs.form);
        let formulario = document.getElementById('formarticulos');
        let formData = new FormData(formulario);

        //Guardo en un auxiliar los otros valores
        let aux = dataeditando;

        fetch('api/Data/GrabarArticulo', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(res => {

            //Le asocio los otros valores que no han sido modificados, ya que le dio a grabar la zona de articulo
            res.imagenesExtras = aux.imagenesExtras;

            if (indexeditando == -1) {

                var array = [...datarticulos];
                array.push(res);
                setdatarticulos(array);
            }
            else {
                var array = [...datarticulos];
                array[indexeditando] = res;
                setdatarticulos(array);
            }

            setdataeditando(null);
            setindexeditando(null);
            setstatePage(DataStatePage.dsSearch);

            setalert(PopUpResult.OK);          
        }).catch(error => {
            setalert(PopUpResult.KO);
        });
    }

    const nuevoDataPage = () => {
        //LLama a obtener el idioma vacio, que es el que pondra el estado
        getDataVacia();
        setindexeditando(-1);
    }

    const cancelarDataPage = () => {

        setdataeditando(null);
        setindexeditando(null);
        setstatePage(DataStatePage.dsSearch);
        setloadingediting(true);
    }

    const deshacerDataPage = () => {
        //Si el que estabamos editando era uno nuevo al deshacer nos vamos a la de buqueda
        if (this.indexeditando == -1)
        {
            setdataeditando(null);
            setindexeditando(null);
            setstatePage(DataStatePage.dsSearch);
            setloadingediting(true);            
        }
        //Sino, es que estabamos en un item valido
        //else {
        //    //Inicializo a los datos que tenia cuando se puso a editar el articulo
        //    if (dataeditando != null)
        //        this.diasVisualizando = dataeditando.diasVisualizar;

        //    //Actualizo la pantalla
        //    this.forceUpdate()
        //}
    }

    const onClosePopUpResult = () => {
        setalert(null);
    }


    //Metodo sobre Definiciones

    const getDataVaciaDefinicion = () => {

        var jsonData = JSON.stringify(dataeditando.id_Articulo);

        fetch('api/Data/GetArticuloDefVacio', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(res =>
        {
            setdataeditandoDefinicion(res);
            setstatePageDefinicion(DataStatePage.dsInsert);
        }).catch(error => {
            setdataeditandoDefinicion(null);
        });
    }

    const grabarDataPageDefinicion = (event) => {

        //Obtengo los datos
        let formulario = document.getElementById('formdefinicion');
        let formData = new FormData(formulario);
        //const data = new FormData(this.refs.form);

        fetch('api/Data/GrabarArticuloDef', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(res => {

            if (dataeditando.definiciones == null)
                dataeditando.definiciones = [];

            //Si estamos añadiendo uno nuevo lo meto dentro de la lista de regiones
            if (indexeditandoDefinicion == -1)
                dataeditando.definiciones.push(res);
            //Sino, es que estamos editando uno
            else
                dataeditando.definiciones[indexeditandoDefinicion] = res;

            setdataeditandoDefinicion(null);
            setindexeditandoDefinicion(null);

            setstatePageDefinicion(DataStatePage.dsSearch);
            setalert(PopUpResult.OK);        
        }).catch(error => {
            setalert(PopUpResult.KO);            
        });
    }

    const nuevoDataPageDefinicion = () => {

        getDataVaciaDefinicion();
        setindexeditandoDefinicion(-1);
    }

    const cancelarDataPageDefinicion = () => {
        setdataeditandoDefinicion(null);
        setindexeditandoDefinicion(null);

        setstatePageDefinicion(DataStatePage.dsSearch);
    }

    const deshacerDataPageDefinicion = () => {
        //Si el que estabamos editando era uno nuevo al deshacer nos vamos a la de buqueda
        if (indexeditandoDefinicion == -1)
            setstatePageDefinicion(DataStatePage.dsSearch);
        //Sino, es que estabamos en un item valido
        //else
          //  this.forceUpdate()
    }

    //Metodo sobre Imagenes Extras

    const getDataVaciaImagenExtra = () => {

        var jsonData = JSON.stringify(dataeditando.id_Articulo);

        fetch('api/Data/GetImagenExtraArticuloVacio', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(res => {
            setdataeditandoImagenExtra(res);
            setstatePageImagenExtra(DataStatePage.dsInsert);
        }).catch(error => {
            setdataeditandoImagenExtra(null);
        });
    }

    const grabarDataPageImagenExtra = (event) => {

        //Obtengo los datos
        let formulario = document.getElementById('formextras');
        let formData = new FormData(formulario);
        //const data = new FormData(this.refs.form);

        fetch('api/Data/GrabarImagenExtra', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(res => {

            if (dataeditando.imagenesExtras == null)
                dataeditando.imagenesExtras = [];

            //Si estamos añadiendo uno nuevo lo meto dentro de la lista de regiones
            if (indexeditandoImagenExtra == -1)
                dataeditando.imagenesExtras.push(res);
            //Sino, es que estamos editando uno
            else
                dataeditando.imagenesExtras[indexeditandoImagenExtra] = res;

            setdataeditandoImagenExtra(null);
            setindexeditandoImagenExtra(null);
            setstatePageImagenExtra(DataStatePage.dsSearch);
            setalert(PopUpResult.OK);

        }).catch(error => {
            setalert(PopUpResult.KO);            
        });
    }

    const nuevoDataPageImagenExtra = () => {

        getDataVaciaImagenExtra();
        setindexeditandoImagenExtra(-1);
    }

    const cancelarDataPageImagenExtra = () => {
        setdataeditandoImagenExtra(null);
        setindexeditandoImagenExtra(null);
        setstatePageImagenExtra(DataStatePage.dsSearch);
    }

    const deshacerDataPageImagenExtra = () => {
        //Si el que estabamos editando era uno nuevo al deshacer nos vamos a la de buqueda
        if (indexeditandoImagenExtra == -1)
            setstatePageImagenExtra(DataStatePage.dsSearch);
        //Sino, es que estabamos en un item valido
        //else
          //  this.forceUpdate()
    }

    //METODO SOBRE EL GRID articuloS

    const editGridDataPage = (valor, index) => {

        setdataeditando(null);
        setloadingediting(true);

        if (valor != null) {
            var jsonData = JSON.stringify({ idofi: valor.id_Oficina, idpoi: valor.id_Poi, idart: valor.id_Articulo });

            fetch('api/Data/GetArticulo', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {

                setindexeditando(index);
                setdataeditando(res);
                setstatePage(DataStatePage.dsEdit);
                setloadingediting(false);
                setalert(null);            
            }).catch(error => {

            });
        }
    }

    const deleteGridDataPage = (valor, index) => {

        if (valor != null) {
            var jsonData = JSON.stringify({ idofi: valor.id_Oficina, idpoi: valor.id_Poi, idart: valor.id_Articulo });

            fetch('api/Data/EliminarArticulo', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res) {
                    //Si todo salie correcto limpio los valores de edicion
                    setindexeditando(index);
                    setdataeditando(res);

                    if (datarticulos != null) {
                        var array = [...datarticulos]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        //Modificao el estado de data para que refresque la pantalla
                        setdatarticulos(array);
                        setalert(PopUpResult.OK);
                    }
                }
            }).catch(error => {
                setalert(PopUpResult.KO);                
            });
        }
    }

    //METODO SOBRE EL GRID Definiciones

    const editGridDataPageDefinicion = (valor, index) => {

        setdataeditandoDefinicion(valor);
        setindexeditandoDefinicion(index);
        setstatePageDefinicion(DataStatePage.dsEdit);
    }

    const deleteGridDataPageDefinicion = (valor, index) => {

        if (valor != null) {
            var jsonData = JSON.stringify({ idofi: valor.id_Oficina, idpoi: valor.id_Poi, idart: valor.id_Articulo, idartdef: valor.id_Art_Def });

            fetch('api/Data/EliminarArticuloDef', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res) {

                    if (dataeditando.definiciones != null) {
                        var array = [...dataeditando.definiciones]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        //Actualizo las promociones con el nuevo valor
                        dataeditando.definiciones = array;

                        setdataeditandoDefinicion(null);
                        setindexeditandoDefinicion(null);
                        
                        //Modificao el estado de data para que refresque la pantalla
                        setalert(PopUpResult.OK);
                    }
                }
            }).catch(error => {
                setalert(PopUpResult.KO);
            });
        }
    }

    //METODO SOBRE EL GRID IMAGENES EXTRAS

    const editGridDataPageImagenExtra = (valor, index) => {

        setdataeditandoImagenExtra( valor);
        setindexeditandoImagenExtra(index);
        setstatePageImagenExtra(DataStatePage.dsEdit);
    }

    const deleteGridDataPageImagenExtra = (valor, index) => {

        if (valor != null) {
            var jsonData = JSON.stringify(valor.id_Extra_Img);

            fetch('api/Data/EliminarImagenExtra', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res) {

                    if (dataeditando.imagenesExtras != null) {
                        var array = [...dataeditando.imagenesExtras]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        //Actualizo las promociones con el nuevo valor
                        dataeditando.imagenesExtras = array;

                        //Si todo salie correcto limpio los valores de edicion
                        setdataeditandoImagenExtra(null);
                        setindexeditandoImagenExtra(null);

                        //Modificao el estado de data para que refresque la pantalla
                        setalert(PopUpResult.OK);
                    }
                }
            }).catch(error => {
                setalert(PopUpResult.KO);
            });
        }
    }

    //METODOS DE RENDERIZADO DE LA PANTALLA

    //Metodos render ARTICULOS

    function renderSearchArticulos(articulos) {
        let cabeceros = props.idRol == Roles.SuperUsuario ? ["Articulo", "Inventario", "Precio", "Categoria", "Estado", "Art."] : ["Articulo", "Inventario", "Precio", "Categoria", "Estado"]
        let valoreshow = props.idRol == Roles.SuperUsuario ? ["nombre", "cantidad", "precioBase", "id_Categoria", "estado", "id_Articulo"] : ["nombre", "cantidad", "precioBase", "id_Categoria", "estado"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "id_Categoria", items: categorias });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "visible", items: OpcionVisibilidad });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "estado", items: EstadosArticulo });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloCurrency, fieldname: "precioBase" });


        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={articulos} datasourcefields={datasourceFields} onEdit={editGridDataPage} onDelete={deleteGridDataPage} permitefiltrar={true} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={10} />);
    }

    function renderInsertEditArticulos()
    {
        //Ponemos el nombre general el valor local que tenemos en dicho momento
        let Nombre = loadingediting ? <p><CircularProgress color="secondary" /></p> :
            (dataeditando != null && dataeditando.id_Articulo > 0 ? dataeditando.nombre : "Nuevo Articulo");

        //Si estamos cargando el articulo ponemos el buscando, sino, renderizamos los datos generales del articulo actual
        let datosGenerales = loadingediting ? <p><CircularProgress color="secondary" /></p>
            : renderInsertEditDatosGenerales(dataeditando)

        //Si estamos cargando el articulo ponemos el buscando, sino, renderizamos los datos generales del articulo actual
        let datosDefiniciones = loadingediting ? <p><CircularProgress color="secondary" /></p>
            : renderOpcionesDefiniciones(dataeditando.definiciones)

        //Si estamos cargando el articulo ponemos el buscando, sino, renderizamos los datos generales del articulo actual
        let datosImagenesExtraarticulo = loadingediting ? <p><CircularProgress  color="secondary" /></p>
            : renderOpcionesImagenesExtra(dataeditando.imagenesExtras)


        let tabs = [];

        tabs = [
            {
                tabButton: "Datos Generales",
                tabIcon: Info,
                tabContent: (datosGenerales)
            }];

        if (dataeditando != null && dataeditando.id_Articulo > 0) {

            tabs.push({
                tabButton: "Particularidades",
                tabIcon: Toc,
                tabContent: (datosDefiniciones)
            });

            tabs.push({
                tabButton: "Imagenes Extra",
                tabIcon: Collections,
                tabContent: (datosImagenesExtraarticulo)
            });
        }


        return (<OthelloTituloPanelData icon="local_grocery_store" titulo={Nombre} margentop={4}>
            <div style={{ backgroundColor: '#FFFFFF' }}>
                <NavPills
                    color="rose"
                    tabs={tabs}
                />
            </div>
        </OthelloTituloPanelData>
        );
    }

    //Metodos render datos Generales 

    function renderInsertEditDatosGenerales(articulo) {

        return (<div style={{ backgroundColor: '#f0f0f0', padding: '10px', marginBottom: '10px' }}>
            <Grid container xs={10}>
                <Grid item xs={9} >
                    <OthelloBotonera statePage={statePage} onNuevo={nuevoDataPage} onGrabar={grabarDataPage} onCancel={cancelarDataPage} onDeshacer={deshacerDataPage} />
                </Grid>
            </Grid>
            <form id="formarticulos" >
                <input id="id_Oficina" name="id_Oficina" type="hidden" value={articulo.id_Oficina} />
                <input id="Id_Articulo" name="id_Articulo" type="hidden" value={articulo.id_Articulo} />
                <input id="Id_Poi" name="id_Poi" type="hidden" value={articulo.id_Poi} />
                <Grid container>
                    <Grid item xs={12} lg={12}>
                        <br />
                        <OthelloTitulo titulo="Datos Generales" />
                    </Grid>
                </Grid>
                <Grid container xs={10}>
                    <Grid item xs={5} sm={4} lg={3}>
                        <OthelloEdit label="Nombre" fieldname="nombre" currentvalue={articulo.nombre} />
                    </Grid>
                    <Grid item xs={5} sm={3} lg={2}>
                        <OthelloComboBox label='Categoria' fieldname="id_Categoria" items={categorias} currentvalue={articulo.id_Categoria} />
                    </Grid>
                    <Grid item xs={5} sm={3} lg={2}>
                        <OthelloComboBox label='Marca' fieldname="id_Marca" items={marcas} currentvalue={articulo.id_Marca} />
                    </Grid>
                    <Grid item xs={5} sm={3} lg={2}>
                        <OthelloEdit label="Orden Visual" fieldname="ordenVisual" currentvalue={articulo.ordenVisual} />
                    </Grid>
                    <Grid item xs={5} sm={3} lg={1}>
                        <OthelloComboBox label='Visible' fieldname="visible" items={OpcionVisibilidad} currentvalue={articulo.visible} />
                    </Grid>
                    <Grid item xs={5} sm={3} lg={2}>
                        <OthelloEdit label="Existencias" fieldname="cantidad" currentvalue={articulo.cantidad} />
                    </Grid>
                    <Grid item xs={5} sm={3} lg={2}>
                        <OthelloEdit label="Aviso Existencias" fieldname="umbralExistencias" currentvalue={articulo.umbralExistencias} />
                    </Grid>
                    <Grid item xs={5} sm={3} lg={2}>
                        <OthelloEdit label="Alergenos" fieldname="alergenos" currentvalue={articulo.alergenos} />
                    </Grid>
                    <Grid item xs={5} sm={3} lg={2}>
                        <OthelloEdit label="Precio" fieldname="preciobasetString" currentvalue={articulo.precioBase} />
                    </Grid>
                    <Grid item xs={5} sm={3} lg={2}>
                        <OthelloEdit label="Precio Rebajado" fieldname="preciorebajadotString" currentvalue={articulo.precioRebajado} />
                    </Grid>
                    <Grid item xs={5} sm={3} lg={2}>
                        <OthelloEdit label="Cant. Max Venta" fieldname="cantMaxVenta" currentvalue={articulo.cantMaxVenta} />
                    </Grid>
                    <Grid item xs={5} sm={3} lg={2}>
                        <OthelloEdit label="SKU" fieldname="sku" currentvalue={articulo.sku} />
                    </Grid>
                    <Grid item xs={5} sm={3} lg={2}>
                        <OthelloEdit label="Peso (kg)" fieldname="peso" currentvalue={articulo.peso} />
                    </Grid>
                    <Grid item xs={5} sm={3} lg={2}>
                        <OthelloComboBox label='Con Valoraciones' fieldname="tieneValoraciones" items={OpcionSiNo} currentvalue={articulo.tieneValoraciones} />
                    </Grid>
                    <Grid item xs={5} sm={3} lg={2}>
                        <OthelloEdit label="Dimensiones" fieldname="dimensiones" currentvalue={articulo.dimensiones} />
                    </Grid>
                    <Grid item xs={5} sm={3} lg={2}>
                        <OthelloComboBox label='Estado' fieldname="estado" items={EstadosArticulo} currentvalue={articulo.estado} />
                    </Grid>
                    <Grid item xs={5} sm={3} lg={2}>
                        <OthelloComboBox label='Envio Gratis' fieldname="envioGratis" items={OpcionSiNo} currentvalue={articulo.envioGratis} />
                    </Grid>
                    <Grid item xs={5} sm={3} lg={2}>
                        <OthelloComboBox label='En Promocion' fieldname="enPromocion" items={OpcionSiNo} currentvalue={articulo.enPromocion} />
                    </Grid>
                    <Grid item xs={5} sm={3} lg={2}>
                        <OthelloComboBox label='Ver Stock' fieldname="verStockRestante" items={OpcionSiNo} currentvalue={articulo.verStockRestante} />
                    </Grid>
                    <Grid item xs={5} sm={3} lg={2}>
                        <OthelloComboBox label='Relevante' fieldname="relevante" items={OpcionSiNo} currentvalue={articulo.relevante} />
                    </Grid>
                </Grid>
                <Grid container xs={10}>
                    <Grid item xs={10} sm={10}>
                        <OthelloEdit label="Descripcion Breve" fieldname="descripcion" currentvalue={articulo.descripcion} rows={3} />
                    </Grid>
                </Grid>
                <Grid container xs={10}>
                    <Grid item xs={10} sm={10}>
                        <OthelloEdit label="Descripcion Completa" fieldname="descripcionLarga" currentvalue={articulo.descripcionLarga} rows={6} />
                    </Grid>
                </Grid>
                <Grid container xs={10}>
                    <Grid item xs={10} sm={10}>
                        <OthelloEdit label="Informacion Adicional" fieldname="infoAdicional" currentvalue={articulo.infoAdicional} rows={3} />
                    </Grid>
                </Grid>
                <Grid container xs={10}>
                    <Grid item xs={10} sm={5} lg={2}>
                        <br />
                        <p>Imagen</p>
                        <ImageUpload
                            id="ImageUrl" name="imageUrl"
                            imageUrl={articulo.imageUrl}
                            addButtonProps={{
                                color: "rose",
                                round: true
                            }}
                            changeButtonProps={{
                                color: "rose",
                                round: true
                            }}
                            removeButtonProps={{
                                color: "danger",
                                round: true
                            }}
                        />
                    </Grid>
                </Grid>
            </form>
        </div>)
    }


    //Metodos render Definiciones

    function renderOpcionesDefiniciones(definiciones) {

        let busquedaDefiniciones = renderSearchDefiniciones(definiciones);

        let edicionDefinicion = statePageDefinicion == DataStatePage.dsEdit || statePageDefinicion == DataStatePage.dsInsert ? renderInsertEditDefinicion(dataeditandoDefinicion) : "";

        //#99d9b7
        return (<div style={{ backgroundColor: '#f0f0f0', padding: '10px', marginBottom: '10px' }}>
            <Grid container xs={10}>
                <Grid item xs={10} >
                    {edicionDefinicion}
                </Grid>
                <Grid item xs={9} >
                    <OthelloBotonera statePage={statePageDefinicion} onNuevo={nuevoDataPageDefinicion} forzarnuevo={true} />
                </Grid>
                <Grid item xs={12} >
                    {busquedaDefiniciones}
                </Grid>
            </Grid>
        </div>
        );
    }

    function renderSearchDefiniciones(definiciones) {
        let cabeceros = idRol == Roles.SuperUsuario ? ["Articulo", "Inventario", "Precio", "Visible", "Art."] : ["Articulo", "Inventario", "Precio", "Visible"]
        let valoreshow = idRol == Roles.SuperUsuario ? ["descripcion", "cantidad", "precio", "visible", "id_Art_Def"] : ["descripcion", "cantidad", "precio", "visible",];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "visible", items: OpcionVisibilidad });

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={definiciones} datasourcefields={datasourceFields} onEdit={editGridDataPageDefinicion} onDelete={deleteGridDataPageDefinicion} permitefiltrar={false} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={5} />);
    }

    function renderInsertEditDefinicion(definicion) {

        if (definicion != null) {
            let Nombre = definicion != null && definicion.id_Art_Def > 0 ? "Editar Particularidad" : "Nueva Particularidad";

            return (
                <OthelloTituloPanelData icon="toc" titulo={Nombre} margentop={4}>
                    <div style={{ backgroundColor: '#FFFFFF' }}>
                        <Grid container>
                            <Grid item xs={12} >
                                <OthelloBotonera statePage={statePageDefinicion} onNuevo={nuevoDataPageDefinicion} onGrabar={grabarDataPageDefinicion} onCancel={cancelarDataPageDefinicion} onDeshacer={deshacerDataPageDefinicion} />
                            </Grid>
                        </Grid>                
                <form id="formdefinicion" >
                    <Grid container xs={12}>
                        <input id="id_Oficina" name="id_Oficina" type="hidden" value={definicion.id_Oficina} />
                        <input id="Id_Articulo" name="id_Articulo" type="hidden" value={definicion.id_Articulo} />
                        <input id="Id_Poi" name="id_Poi" type="hidden" value={definicion.id_Poi} />
                        <input id="Id_Art_Def" name="Id_Art_Def" type="hidden" value={definicion.id_Art_Def} />
                        <Grid item xs={5} sm={4} lg={3}>
                            <OthelloEdit label="Descripcion" fieldname="descripcion" currentvalue={definicion.descripcion} />
                        </Grid>
                        <Grid item xs={5} sm={3} lg={1}>
                            <OthelloComboBox label='Visible' fieldname="visible" items={OpcionVisibilidad} currentvalue={definicion.visible} />
                        </Grid>
                        <Grid item xs={5} sm={3} lg={2}>
                            <OthelloEdit label="Existencias" fieldname="cantidad" currentvalue={definicion.cantidad} />
                        </Grid>
                        <Grid item xs={5} sm={3} lg={2}>
                            <OthelloEdit label="Precio" fieldname="preciotString" currentvalue={definicion.precio} />
                        </Grid>
                    </Grid>
                        </form>
                </div>
            </OthelloTituloPanelData>
            );
        }
        else
            return "";
    }

    //Metodos render Imagenes Extras

    function renderOpcionesImagenesExtra(imagenes) {

        let busquedaImagenes = renderSearchImagenesExtra(imagenes);

        let edicionImagenes = statePageImagenExtra == DataStatePage.dsEdit || statePageImagenExtra == DataStatePage.dsInsert ? renderInsertEditImagenExtra(dataeditandoImagenExtra) : "";

        //#99d9b7
        return (<div style={{ backgroundColor: '#f0f0f0', padding: '10px', marginBottom: '10px' }}>
            <Grid container xs={10}>
                <Grid item xs={10} >
                    {edicionImagenes}
                </Grid>
                <Grid item xs={9} >
                    <OthelloBotonera statePage={statePageImagenExtra} onNuevo={nuevoDataPageImagenExtra} forzarnuevo={true} />
                </Grid>
                <Grid item xs={12} >
                    {busquedaImagenes}
                </Grid>
            </Grid>
        </div>
        );
    }

    function renderSearchImagenesExtra(imagenes) {
        //Generamos los valores de cada una de las lineas de grid
        let cabeceros = props.idRol == Roles.SuperUsuario ? ["Imagen", "ID"] : ["Imagen"];
        let valoreshow = props.idRol == Roles.SuperUsuario ? ["imageUrl", "id_Extra_Img"] : ["imageUrl"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloImagen, fieldname: "imageUrl", items: [] });

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={imagenes} datasourcefields={datasourceFields} onEdit={editGridDataPageImagenExtra} onDelete={deleteGridDataPageImagenExtra} permitefiltrar={false} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={5} />);
    }

    function renderInsertEditImagenExtra(imagenextra)
    {
        if (imagenextra != null) {
            let Nombre = imagenextra != null && imagenextra.id_Extra_Img > 0 ? "Editar Imagen" : "Nueva Imagen";

            return (
                <OthelloTituloPanelData icon="collections" titulo={Nombre} margentop={4}>
                    <div style={{ backgroundColor: '#FFFFFF' }}>
                        <Grid container>
                            <Grid item xs={12} >
                                <OthelloBotonera statePage={statePageImagenExtra} onNuevo={nuevoDataPageImagenExtra} onGrabar={grabarDataPageImagenExtra} onCancel={cancelarDataPageImagenExtra} onDeshacer={deshacerDataPageImagenExtra} />
                            </Grid>
                        </Grid>
                        <form id="formextras" >
                            <Grid container xs={12}>
                                <input id="Id_Oficina" name="Id_Oficina" type="hidden" value={imagenextra.id_Oficina} />
                                <input id="Id_Poi" name="Id_Poi" type="hidden" value={imagenextra.id_Poi} />
                                <input id="Id_Articulo" name="Id_Articulo" type="hidden" value={imagenextra.id_Articulo} />
                                <input id="Id_Extra_Img" name="Id_Extra_Img" type="hidden" value={imagenextra.id_Extra_Img} />
                                <input id="NombrePoi" name="NombrePoi" type="hidden" value={dataeditando.nombre} />
                                <Grid item xs={12} sm={2}>
                                    <br />
                                    <legend>Imagen (512x384px)</legend>
                                    <ImageUpload
                                        id="imageUrl" name="imageUrl"
                                        imageUrl={imagenextra.imageUrl}
                                        addButtonProps={{
                                            color: "rose",
                                            round: true
                                        }}
                                        changeButtonProps={{
                                            color: "rose",
                                            round: true
                                        }}
                                        removeButtonProps={{
                                            color: "danger",
                                            round: true
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </form>
                    </div>
                </OthelloTituloPanelData>
            );
        }
        else
            return "";
    }



    let busqueda = loading ? <p><CircularProgress color="secondary" /></p> : renderSearchArticulos(datarticulos)

    let edicion = statePage == DataStatePage.dsEdit || statePage == DataStatePage.dsInsert ? renderInsertEditArticulos() : "";

    let alerta = alert != null ? <OthelloPopUpResult titulo="" alert={alert} onClosePopUpResult={onClosePopUpResult} /> : "";

    let tiendafinish =  nombretienda != null ? nombretienda : "";
    let artname = "Articulos" + tiendafinish;

    return (
        <Grid container>
            <Grid item xs={12} sm={12} md={12}>
                {alerta}
            </Grid>
            <Grid container>
                <Grid item xs={12} >
                    <OthelloBotonera statePage={statePage} onNuevo={nuevoDataPage} forzarnuevo={true} />
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
                <OthelloTituloPanelData titulo={artname} margentop={0}>
                    <Grid container>
                        <Grid item xs={12}>
                            {busqueda}
                        </Grid>
                    </Grid>
                </OthelloTituloPanelData>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
                {edicion}
            </Grid>
        </Grid>    
    );
}

